module.exports = __webpack_public_path__ + "img/weddings_2.6e00d435.jpg";